import { createAction, props } from '@ngrx/store';

export const onBlockingRequestStarted = createAction(
    '[Aumico-Core] onBlockingRequestStarted',
    props<{ payload: string }>(),
);

export const onBlockingRequestEnded = createAction(
    '[Aumico-Core] onBlockingRequestEnded',
    props<{ payload: string }>(),
);
export const onResetOverlay = createAction('[Aumico-Core] onResetOverlay');
